module.exports = __webpack_public_path__ + "static/media/Exploud_gaussian2.b38a8c25.png";